import { useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';
import isEmpty from 'lodash/isEmpty';
import { CACHE_TIME_MS, PAGE_SIZE, REFETCH_INTERVAL_MS, DEFAULT_PAGE, STALE_TIME_MS } from '../pickerConstatns';

export const useDropdownData = ({ fetcher, inputValue = '', queryKey, isOpen, allOption, enabled = true }) => {
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching, isLoading, refetch, error } =
        useInfiniteQuery(
            queryKey,
            async ({ pageParam = DEFAULT_PAGE }) => {
                const { items, total } = await fetcher({
                    searchText: inputValue,
                    pageSize: PAGE_SIZE,
                    page: pageParam,
                    queryKey,
                });
                const hasMore = items.length > 0 && pageParam * PAGE_SIZE < total;

                return {
                    items,
                    hasMore,
                    total,
                    pageParam,
                    searchText: inputValue,
                };
            },
            {
                enabled: isOpen && enabled,
                getNextPageParam: (lastPage, __) => {
                    return lastPage?.total > lastPage?.pageParam * PAGE_SIZE && lastPage?.pageParam + 1;
                },
                keepPreviousData: false,
                cacheTime: CACHE_TIME_MS,
                staleTime: STALE_TIME_MS,
                refetchInterval: REFETCH_INTERVAL_MS,
                refetchOnMount: false,
                refetchOnWindowFocus: false,
            }
        );

    const options = useMemo(() => {
        if (!data?.pages) {
            return [];
        }
        const flatData = data.pages.map(page => page?.items || []).flat();

        const resolvedData = [];

        if (allOption && !isEmpty(flatData)) {
            resolvedData.push(allOption);
        }

        resolvedData.push(...flatData);
        return resolvedData;
    }, [data, allOption]);

    return {
        options,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage: isFetching ?? isFetchingNextPage,
        isLoading,
        refetch,
        error,
    };
};
